// extracted by mini-css-extract-plugin
export default {"viewer":"TermsPdfViewer_viewer__PE-6c"};